import { defineMessages } from 'react-intl';

export default defineMessages({
  buildFailureTitle: {
    id: 'frontbucket.repositoryTable.buildFailure',
    description: 'Title text to display when loading the build statuses fails.',
    defaultMessage: 'Oops!',
  },
  buildFailureDescription: {
    id: 'frontbucket.repositoryTable.buildFailureDescription',
    description:
      'Descriptive text to display when loading the build statuses fails.',
    defaultMessage: `We couldn’t load commit statuses for that repository`,
  },
  privateRepositoryLabel: {
    id: 'frontbucket.dashboard.repositoryCard.privateRepositoryLabel',
    description:
      'Text which provides private repository privacy (for screen readers)',
    defaultMessage: 'Private repository',
  },
  publicRepositoryLabel: {
    id: 'frontbucket.dashboard.repositoryCard.publicRepositoryLabel',
    description:
      'Text which provides public repository privacy (for screen readers)',
    defaultMessage: 'Public repository',
  },
});
